export const colorMapping :{[key: string]:string} = {
    'New': '#F59E0B',
    'Open': '#EF4444',
    'Reopened': '#EF4444',
    'In progress': '#EF4444',
    'Pending': '#22D3EE',
    'Closed': '#94A3B8',
    'Resolved': '#94A3B8',
};
